"use client";
import React from "react";
import { SearchComponent } from "@/components/common/SearchComponent";


// DW'S INSIGHT 로고 컴포넌트
function DWInsightLogo() {
  return (
    <div className="w-full flex justify-center items-center mx-auto">
      {/* 통합된 DW'S INSIGHT 로고 SVG 사용 */}
      <div className="w-full max-w-[648px] transform-gpu scale-[0.6] lg:scale-[0.8] lg:scale-[0.8] lg:scale-[0.9] lg:scale-100 2lg:scale-110 origin-center" style={{ minWidth: '400px' }}>
        <img 
          src="/svg/dwinsights_title.svg" 
          alt="DW'S INSIGHT" 
          className="w-full h-auto"
          style={{ minWidth: '400px' }}
        />
      </div>
    </div>
  );
}


export function NewHeroSection() {

  return (
    <div className="w-full min-h-[300px] pt-[100px] lg:pt-[170px] pb-[20px] lg:pb-[50px] flex flex-col items-center justify-center relative bg-white overflow-visible">
      {/* 전체 컨테이너 - 최대 1920px, 중앙 정렬 */}
      <div className="w-full max-w-[1920px] mx-auto px-3 lg:px-4 lg:px-6 lg:px-8 lg:px-12">
        {/* 내부 컨텐츠 컨테이너 - 반응형 최대 너비, 중앙 정렬 */}
        <div className="w-full max-w-[calc(100vw-24px)] lg:max-w-[400px] lg:max-w-[600px] lg:max-w-[800px] lg:max-w-[990px] 2lg:max-w-[1200px] mx-auto flex flex-col items-center justify-center">
          
          {/* 1. DW'S INSIGHT 로고 (메인 히어로 타이틀) */}
          <div className="flex justify-center w-full">
            <DWInsightLogo />
          </div>
          
          {/* 2. 슬로건 텍스트 */}
          <div className="text-center text-gray-700 text-sm lg:text-2xl font-normal font-['Pretendard'] leading-relaxed mb-6 lg:mb-16 px-2 lg:px-4">
            아이뱅크 디지털웍스가 만든 실무자용 AI 인사이트 플랫폼
          </div>
          
          {/* 3. 검색바 */}
          <div className="w-full flex justify-center">
            <SearchComponent />
          </div>
          
        </div>
      </div>
    </div>
  );
}
